import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';

interface Props {
  lineCount?: number;
  className?: string;
}

export function EmptyPlaceholder({ lineCount = 1, className }: Props) {
  const lines: JSX.Element[] = [];
  for (let i = 0; i < lineCount; i += 1) {
    const line = <div className={styles.placeholder_line} key={i} />;
    lines.push(line);
  }
  return <section className={className}>{lines}</section>;
}

EmptyPlaceholder.propTypes = {
  lineCount: PropTypes.number,
  className: PropTypes.string,
};
